<video class="video-cont" [src]="videoFile.url" controls autoplay id={{videoFile.FileName}} #ftiMegaPlayer crossorigin="anonymous"></video>
<mat-icon class="key-lock">{{ isEncrypted ? 'key' : 'key_off' }}</mat-icon>